import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useAsyncDebounce } from 'react-table'
import Icon from '@mdi/react'
import { mdiClose, mdiMagnify } from '@mdi/js'
import qs from 'qs'

import {
  StyledSearchContainer,
  StyledInput,
  StyledClearSearchBtn,
  StyledClearSearchIcon,
} from './styles'
import theme from 'theme_'
import { useQuery } from 'app/hooks'

interface CommonSearchProps {
  setSearchValue: (value: string) => void
  placeholder: string
  disableQuerySearch?: boolean
  /**
   * When we 'disableQuerySearch': we should pass 'externalSearchValue'
   */
  externalSearchValue?: string
}

export function CommonSearch({
  setSearchValue,
  placeholder,
  disableQuerySearch,
  externalSearchValue,
}: CommonSearchProps) {
  const history = useHistory()
  const query = useQuery()
  const [value, setValue] = useState('')

  useEffect(() => {
    if (
      !disableQuerySearch &&
      query.search &&
      typeof query.search === 'string'
    ) {
      const searchValue = query.search
      setValue(searchValue)
      setSearchValue(searchValue)
    }
  }, [disableQuerySearch, query.search, setSearchValue])

  const onChange = useAsyncDebounce((value) => {
    setSearchValue(value)
    if (!disableQuerySearch) {
      history.push({
        search: value ? qs.stringify({ search: value }) : '',
      })
    }
  }, 500)

  const handleClear = () => {
    setValue('')
    setSearchValue('')
    if (!disableQuerySearch) {
      history.push({
        search: '',
      })
    }
  }

  const shouldShowClearBtn = !!value?.length || !!externalSearchValue?.length

  return (
    <StyledSearchContainer>
      <Icon path={mdiMagnify} size={1} color={theme.colors.otterWarmBlack} />
      <StyledInput
        value={disableQuerySearch ? externalSearchValue : value}
        onChange={(e) => {
          setValue(e.target.value)
          disableQuerySearch
            ? setSearchValue(e.target.value)
            : onChange(e.target.value)
        }}
        placeholder={placeholder}
      />
      {shouldShowClearBtn && (
        <StyledClearSearchBtn onClick={handleClear}>
          <StyledClearSearchIcon path={mdiClose} size={1} />
        </StyledClearSearchBtn>
      )}
    </StyledSearchContainer>
  )
}
